import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const FONT_SIZES = [
  { label: 'A',  value: '13px' },
  { label: 'A+', value: '15px' },
  { label: 'A++', value: '17px' },
];
const FONT_KEY = 'sf_font_size';

function applyFontSize(size) {
  document.documentElement.style.setProperty('--base-font-size', size);
}

export default function Topbar({ title, onMenuClick }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [fontIdx, setFontIdx] = useState(() => {
    try {
      const stored = localStorage.getItem(FONT_KEY);
      const idx = FONT_SIZES.findIndex(f => f.value === stored);
      return idx >= 0 ? idx : 0;
    } catch { return 0; }
  });

  useEffect(() => {
    applyFontSize(FONT_SIZES[fontIdx].value);
  }, [fontIdx]);

  const cycleFont = () => {
    const next = (fontIdx + 1) % FONT_SIZES.length;
    setFontIdx(next);
    try { localStorage.setItem(FONT_KEY, FONT_SIZES[next].value); } catch {}
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="topbar">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button className="btn btn-icon" onClick={onMenuClick}
          style={{ display: 'none' }} id="menu-btn"
          aria-label="Open navigation">
          <i className="ti ti-menu-2" />
        </button>
        <span className="topbar-title">{title}</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <button className="btn btn-sm" onClick={cycleFont}
          title={`Font size: ${FONT_SIZES[fontIdx].label} — click to cycle`}
          style={{ fontWeight: 600, minWidth: 36, fontSize: 11 }}>
          {FONT_SIZES[fontIdx].label}
        </button>
        <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
          {user?.fullName}
        </span>
        <span className="badge badge-gray" style={{ fontSize: 10 }}>
          {user?.role}
        </span>
        <button className="btn btn-sm" onClick={() => navigate('/settings/profile')}>
          <i className="ti ti-user" />
        </button>
        <button className="btn btn-sm" onClick={handleLogout} title="Sign out">
          <i className="ti ti-logout" />
        </button>
      </div>

      <style>{`
        @media (max-width: 768px) {
          #menu-btn { display: inline-flex !important; }
        }
      `}</style>
    </header>
  );
}
